exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._13yMd5ig_lSbg9lZYKby0J{border:3px solid #2b2665;display:inline-block;border-radius:5px;background-color:#2b2665}.VFI3K_ePliSTzO0szeL02{color:#fff;background-color:#2b2665;min-width:180px;padding:.2em 2em;font-size:22px}", ""]);

// exports
exports.locals = {
	"box": "_13yMd5ig_lSbg9lZYKby0J",
	"title": "VFI3K_ePliSTzO0szeL02"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Common/TitleBox/TitleBox.scss
 ** module id = 348
 ** module chunks = 0
 **/